module.exports = __webpack_public_path__ + "img/paytable_icon.02adcf5d.svg";